// Escape user-controlled values before interpolating into print/window HTML (prevents stored XSS).
export function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// Recursively return a copy of `data` with every string value HTML-escaped.
// Use this on any object before building printable HTML from its fields.
export function escapeDeep(data) {
  if (data === null || data === undefined) return data;
  if (typeof data === 'string') return escapeHtml(data);
  if (Array.isArray(data)) return data.map(escapeDeep);
  if (typeof data === 'object') {
    const out = {};
    for (const k of Object.keys(data)) out[k] = escapeDeep(data[k]);
    return out;
  }
  return data;
}

